import { combineReducers, configureStore } from '@reduxjs/toolkit';
import globalReducer from './slices/global/index';
import ralliesPreviewReducer from './slices/ralliesPreview/index';
import rallyGameReducer from './slices/rallyGame/index';
import adminAuthReducer from './adminSlices/auth/index';
import adminRalliesReducer from './adminSlices/rallies/index';
import { useDispatch } from 'react-redux';
const rootReducer = combineReducers({
    global: globalReducer,
    ralliesPreview: ralliesPreviewReducer,
    rallyGame: rallyGameReducer,
    adminAuth: adminAuthReducer,
    adminRallies: adminRalliesReducer,
});
export const store = configureStore({
    reducer: rootReducer,
});
export const useAppDispatch = useDispatch;
